type INum = number;

export const clamp = (num: INum, min: INum, max: INum): INum => Math.min(Math.max(num, min), max);
